<template>
    <ul class="customer-navigation">
        <router-link v-for="(link, key) in links" :key="key" :to="link" v-slot="{ href, route, navigate, isExactActive }">
            <li :class="[isExactActive && 'active', 'customer-navigation-item']">
                <a :href="href" @click="navigate" v-text="route.name"></a>
            </li>
        </router-link>
    </ul>
</template>
<script>
export default {
    name: "CustomerSidebar",

    computed: {
        displayedAddress() {
            return this.customer.address ? this.customer.address.display_name : "";
        }
    },

    data: () => ({
        links: [
            "/user/profile",
            "/user/bookings",
            "/user/penalties",
            "/user/addresses",
            "/user/favorite-shops",
            "/user/vouchers",
            "/user/points",
            "/user/notifications",
        ]
    }),

    props: {
        customer: [Object],
    },

    mounted() {

    },
}
</script>
<style lang="css" scoped>
    .customer-navigation {
        list-style: none;
        padding: 70px 0 0 0;
    }
    .customer-navigation-item {
        padding: 10px 7.5px;
    }
    .customer-navigation-item a {
        color: #555555;
    }
    .customer-navigation-item a:hover {
        color: #EE4036;
    }
    .customer-navigation-item.active a {
        color: #EE4036;
    }
</style>